import { formatPointLabelForAxis } from "../base/utils";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
export const getYAxisFormatter = (viewForm) => function yAxisFormatter() {
    return formatPointLabelForAxis(this.value, viewForm || ChartSelectValueFormatKind.compact, "", viewForm ? {} : { maximumFractionDigits: 0 });
};
export const xAxisFormatter = function xAxisFormatter() {
    return `<div class="labelName">${this.value}</div>`;
};
